const Tier = Object.freeze({
  FREE: 'free',
  PREMIUM: 'premium'
});

// --- Free tier limits (keep in sync with backend tier_utils.py) ---
export const FREE_TIER_ASSET_LIMIT = 5;
export const FREE_TIER_LIABILITY_LIMIT = 3;
export const FREE_TIER_HISTORY_MONTHS = 2;
// ------------------------------------------------------------------

export default Tier;
